import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import SelfAssessmentDashboard from './SelfAssessmentDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanySelfAssessmentDashboard } from './companySelfAssessmentApi';

/** Company Self-Assessment → Dashboard, scoped to this company. */
const CSelfAssessmentDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanySelfAssessmentDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Self-Assessment | Shoorah</title>
      </Helmet>
      <SelfAssessmentDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CSelfAssessmentDashboard;
